import React from "react"

import { Link, withRouter } from "react-router-dom";


import Edit from "./cells/Edit";
import Delete from "./cells/Delete";

import Guarantee from "../modal/Guarantee";
import moment from "moment";
import Confirmation from "../modal/Confirmation";

import BaseTable from "./BaseTable"

import General from "../../../utils/General";
import Backend from "../../../utils/Backend";
import Notify from "../../../utils/Notify";

class PartiesTable extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      live: props.live
    }

    this.table = React.createRef()
  }

  _handleDelete(guarantee){
    Backend.deleteGuarantee(guarantee).then(() => {
      Notify.success("Guarantee Deleted.")
      this.setState({showConfirmationModal: false, selectedGuarantee: null})
      this.table.current.refresh()
    }).catch(e => Notify.error(e.message))
  }

  _getColumns() {

    let columns = [
      {
        Header: 'Date Added',
        id: 'created_at',
        accessor: guarantee => moment(guarantee.created_at).format('DD MMM YYYY'),
        type: "date",
        format: "%d %b %Y"
      },
      {
        Header: 'Guarantee Type',
        id: 'type',
        accessor: guarantee => `${General.snakeCaseToTitleCase(guarantee.type.name)} - ${General.snakeCaseToTitleCase(guarantee.type.description)}`,
      },
      {
        Header: '',
        id: '',
        sortable: false,
        exportable: false,
        Cell: rowInfo => {
          let party = rowInfo.original
          return (
            <div className={"text-end my-auto"}>
              <Edit
                onEditClicked={() => {
                  this.setState({showGuaranteeModal: true, selectedGuarantee: party})
                }}
              />
              <Delete
                onDeleteClicked={() => {
                  this.setState({showConfirmationModal: true, selectedGuarantee: party})
                }}
              />
            </div>
          )
        }
      }
    ]

    return columns

  }

  render() {
    let {
      selectedGuarantee,
      showGuaranteeModal,
      showConfirmationModal
    } = this.state

    const columns = this._getColumns()

    return (
      <>
        <BaseTable
          ref={this.table}
          endpoint={window.Api.Guarantees}
          noDataMessage={"No guarantees found"}
          title={this.props.title}
          columns={columns}
          defaultSorted={[
            {
              id: "created_at",
              desc: true
            }
          ]}
          renderToolbar={() => (
            <>
              <div className="card-toolbar" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-trigger="hover"
                   data-kt-initialized="1" data-bs-original-title="" title="">
                <a
                  href="#"
                  className="btn btn-primary"
                  onClick={() => {
                    this.setState({showGuaranteeModal: true})
                  }}
                >
                  + Add Guarantee
                </a>
              </div>
            </>
          )}
        />
        {
          showGuaranteeModal &&
          <Guarantee
            show={showGuaranteeModal}
            guarantee={selectedGuarantee}
            onHide={() => this.setState({showGuaranteeModal: false, selectedGuarantee: null})}
            onSubmit={() => {
              this.table.current.refresh()
              this.setState({showGuaranteeModal: false, selectedGuarantee: null})
            }}
          />
        }
        {
            showConfirmationModal &&
            <Confirmation
                show={showConfirmationModal}
                onConfirm={() => this._handleDelete(selectedGuarantee)}
                onHide={() => this.setState({showConfirmationModal: false, selectedGuarantee: null})}
            />
        }
      </>
    )

  }

}

export default withRouter(PartiesTable);
